export default {
  flatFee: 0,
  hourlyRate: 10,
  noHonorarium: 20,
  fullAmount: 30,
};
